module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_09_stay-a7d33171be5ce3e8850c7050e34d0638.jpg";